<template>
  <div class="trainer-manager">
    <container>
      <page-title>Edit trainer: {{ trainer.firstName }} {{ trainer.lastName }}</page-title>

      <div class="trainer-manager__row">
        <div class="trainer-manager__content">
          <div class="error" v-if="error">
            {{ error }}
          </div>

          <v-form :handle-submit="handleSubmit">
            <div class="current-photo" v-if="trainer.photoUrl">
              <p>Current Photo:</p>
              <img :src="trainer.photoUrl" :alt="trainer.firstName" width="80px">
            </div>

            <v-text-field
              name="firstName"
              @keyup.enter="handleSubmit"
              v-model="trainer.firstName"
              v-validate="'required'" data-vv-value-path="input" data-vv-name="firstName"
              data-vv-as="first name"
              :message-error="errors && errors.first ? errors.first('firstName') : ''"
              :has-error="errors && errors.has ? errors.has('firstName') : ''"
              :block="true">
              <template slot="label">
                First name: *
              </template>
            </v-text-field>

            <v-text-field
              name="lastName"
              @keyup.enter="handleSubmit"
              v-model="trainer.lastName"
              v-validate="'required'" data-vv-value-path="input" data-vv-name="lastName"
              :message-error="errors && errors.first ? errors.first('lastName') : ''"
              :has-error="errors && errors.has ? errors.has('lastName') : ''"
              :block="true">
              <template slot="label">
                Last name: *
              </template>
            </v-text-field>

            <v-text-field
              name="user.email"
              @keyup.enter="handleSubmit"
              v-model="trainer.user.email"
              v-validate="'required|email'" data-vv-value-path="input" data-vv-name="user.email"
              :message-error="errors && errors.first ? errors.first('user.email') : ''"
              :has-error="errors && errors.has ? errors.has('user.email') : ''"
              :block="true">
              <template slot="label">
                E-mail: *
              </template>
            </v-text-field>

            <v-text-field
              name="nickname"
              @keyup.enter="handleSubmit"
              v-model="trainer.nickname"
              v-validate="'required'" data-vv-value-path="input" data-vv-name="nickname"
              :message-error="errors && errors.first ? errors.first('nickname') : ''"
              :has-error="errors && errors.has ? errors.has('nickname') : ''"
              :block="true">
              <template slot="label">
                Nickname (username): *
              </template>
            </v-text-field>

            <v-text-field
              name="aboutMe"
              v-model="trainer.aboutMe"
              :block="true"
              :multiple-lines="true">
              <template slot="label">
                About me:
              </template>
            </v-text-field>



            <v-text-field
              name="introductionUrl"
              @keyup.enter="handleSubmit"
              v-model="trainer.introductionUrl"
               data-vv-value-path="input" data-vv-name="introductionUrl"
              :block="true">
              <template slot="label">
                Trainer Introduction Web : 
              </template>
            </v-text-field>

            <v-upload-field
              @fileUrl="setPhotoUrl"
              url="trainers/upload-image"
              :block="true">
              <template slot="label">
                Photo upload:
              </template>
            </v-upload-field>

            <v-button @click="handleSubmit" :block="true" :disabled="loading">
              {{ loading ? 'Loading...' : 'Save' }}
            </v-button>
          </v-form>
        </div>

        <update-password :user-id="currentTrainer && currentTrainer.user ? currentTrainer.user.id : null"/>
      </div>
    </container>
  </div>
</template>

<script>
import Vue from 'vue'
import Container from '@/components/Container'
import PageTitle from '@/components/PageTitle'
import VForm from '@/components/Forms/VForm'
import VTextField from '@/components/Forms/VTextField'
import VUploadField from '@/components/Forms/VUploadField'
import VButton from '@/components/Forms/VButton'
import updatePassword from '@/components/LiveRun/Race/TrainerManager/UpdatePassword'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'TrainerManager',
  data: () => ({
    trainer: {
      aboutMe: '',
      firstName: '',
      lastName: '',
      nickname: '',
      photoUrl: '',
      introductionUrl:'',
      user: {
        firstName: '',
        lastName: '',
        activated: true,
        email: '',
        langKey: 'en',
        login: '',
        password: ''
      }
    },
    loading: false,
    error: ''
  }),
  computed: {
    ...mapGetters({
      currentTrainer: 'trainers/trainer'
    })
  },
  methods: {
    async handleSubmit () {
      const isValid = await this.$validator.validateAll()

      if (isValid) {
        this.loading = true

        if (this.trainer.user.password === '') {
          delete this.trainer.user.password
        }

        const isUpdated = await this.updateTrainer(this.trainer)

        this.loading = false

        if (isUpdated) {
          this.$router.push('/admin/trainers')

          return true
        }

        this.error = 'Something wrong while trying to edit the trainer'

        return false
      }
    },
    setPhotoUrl (value) {
      this.trainer.photoUrl = value
    },
    ...mapActions({
      getTrainer: 'trainers/getTrainer',
      updateTrainer: 'trainers/updateTrainer',
      updateTrainerPassword: 'trainers/updateTrainerPassword'
    })
  },
  created () {
    this.getTrainer(this.$route.params.id)
  },
  watch: {
    currentTrainer () {

      console.log("Vue.http.options.root>>----",Vue.http.options.root)
      console.log("this.currentTrainer----",this.currentTrainer)
      console.log(" this.trainer----",this.currentTrainer)
      this.trainer.firstName = this.currentTrainer.firstName
      this.trainer.lastName = this.currentTrainer.lastName
      this.trainer.user.email = this.currentTrainer.user.email
      this.trainer.nickname = this.currentTrainer.nickname
      this.trainer.aboutMe = this.currentTrainer.aboutMe
      this.trainer.photoUrl = this.currentTrainer.photoUrl
      this.trainer.introductionUrl = this.currentTrainer.introductionUrl
    },
    'trainer.firstName' () {
      this.trainer.user.firstName = this.trainer.firstName
    },
    'trainer.lastName' () {
      this.trainer.user.lastName = this.trainer.lastName
    },
    'trainer.nickname' () {
      this.trainer.user.login = this.trainer.nickname
    }
  },
  components: {
    Container,
    PageTitle,
    VButton,
    VForm,
    VTextField,
    VUploadField,
    updatePassword
  }
}
</script>

<style lang="stylus" scoped>
  .trainer-manager
    padding 0 0 30px

    &__row
      display flex
      flex-flow row wrap
      align-items flex-start
      justify-content space-between

    &__content
      background #fff
      padding 15px 30px 30px
      box-shadow 0 2px 6px 0 rgba(0,0,0,0.2)
      flex 1 0 100%

      &:nth-child(1)
        max-width 60%

      &:nth-child(2)
        max-width 37%

      .current-photo
        color #222
        font-size 12px
        text-transform uppercase
        margin 0 0 15px

        img
          margin 5px 0 0

      .error
        padding 15px 30px
        margin 0 0 15px
        text-align center
        background #ff1744
        color #fff
        font-weight 700

      form
        label
          &:not(:last-of-type)
            margin-bottom 20px

        button
          margin 20px 0 0
</style>



// WEBPACK FOOTER //
// Edit.vue?53c10cd4